import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { Button } from 'foundations-components/transitional/components/Button';
import { Box } from 'foundations-components/transitional/components/Box';
import { Flex } from 'foundations-components/components/Flex';
import { useClearAllFilters, useRemoveFilter } from '../publicCatalogFiltersHooks';
import { useSearchParams } from '../../../utils/searchParams';
import { PublicCatalogFilters, mainFilters } from '../publicCatalogConstants';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AppliedFilters = () => {
  const {
    isMobile
  } = useMediaQuery();
  const [searchParams] = useSearchParams();
  const selectedFilterTypes = Object.keys(searchParams).filter(key => !mainFilters.includes(key));
  const clearAllFilters = useClearAllFilters();
  const removeFilter = useRemoveFilter();
  return /*#__PURE__*/_jsx("div", {
    style: {
      overflowX: isMobile ? 'scroll' : 'auto'
    },
    children: /*#__PURE__*/_jsxs(Flex, {
      flexWrap: isMobile ? 'nowrap' : 'wrap',
      gap: "200",
      inlineSize: "fit-content",
      maxInlineSize: "none",
      paddingBlock: isMobile ? '200' : '0',
      paddingInline: isMobile ? '500' : '0',
      children: [Object.entries(PublicCatalogFilters).map(([filterName, filterOptions]) => {
        const filterValuesApplied = searchParams[filterName] || [];
        if (filterValuesApplied.length === 0) {
          return null;
        }
        // language may not have multiple values so only take the last one
        const validFilterValues = filterName === 'language' ? filterValuesApplied.slice(-1) : filterValuesApplied;
        return validFilterValues.map(optionValue => {
          const selectedOptions = [...filterOptions];
          const selectedOption = selectedOptions.find(option => option === optionValue);
          if (!selectedOption) {
            return null;
          }
          return /*#__PURE__*/_jsx(Box, {
            shrink: 0,
            children: /*#__PURE__*/_jsx(Tag, {
              closeable: true,
              "data-test-id": "applied-filter-tag",
              marginInlineStart: "0",
              onCloseClick: () => {
                removeFilter(filterName, selectedOption);
              },
              children: filterName === 'language' ? LanguageNames[selectedOption] : /*#__PURE__*/_jsx(FormattedMessage, {
                message: `academyPublic.catalogPage.filters.${filterName}.options.${selectedOption}`
              })
            })
          }, selectedOption);
        });
      }), Object.keys(selectedFilterTypes).length > 0 && /*#__PURE__*/_jsx(View, {
        inlineSize: "max-content",
        children: /*#__PURE__*/_jsx(Button, {
          marginInlineStart: "300",
          onClick: clearAllFilters,
          use: "link",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.catalogPage.filters.clearFilters"
          })
        })
      })]
    })
  });
};
export default AppliedFilters;